<template>
  <v-container>
    <v-card>
      <v-card-title>Add a new question</v-card-title>
      <v-card outlined class="mx-2 mb-2"
        ><TopicsHierarchy @topicsChanged="onNewTopics"></TopicsHierarchy
      ></v-card>
      <v-card outlined class="mx-2 mb-2"
        ><v-select
          class="mx-3"
          v-model="selectedStep"
          :items="steps"
          label="Step"
          hint="Step"
          persistent-hint
          return-object
          single-line
          clearable
        ></v-select
      ></v-card>
      <v-form ref="form">
        <v-card outlined class="mx-2">
          <v-textarea
            class="mx-4"
            label="Question"
            v-model="question"
            required
            clearable
          ></v-textarea
        ></v-card>
        <v-card-subtitle>Answers</v-card-subtitle>
        <v-card outlined class="mx-2 mb-2 mt-n2"
          ><adding-text-field @added="onAddAnswer"></adding-text-field
        ></v-card>
        <v-card outlined class="mx-2 mb-2">
          <v-select
            class="mx-4 mt-4"
            v-model="correctAnswer"
            :items="answers"
            item-text="value"
            item-value="index"
            label="Select the correct answer"
            single-line
            clearable
          ></v-select
        ></v-card>
        <v-card outlined class="mx-2 mb-2">
          <v-textarea
            class="mx-4"
            label="Explanation"
            v-model="explanation"
            required
            clearable
          ></v-textarea
        ></v-card>
        <v-card class="mx-2 mb-2 px-4" outlined>
          <v-file-input
            label="Click to select image"
            id="fileItem"
            clearable
          ></v-file-input></v-card
      ></v-form>
      <v-card outlined class="mx-2 mb-4">
        <v-select
          class="mx-4 mt-4"
          v-model="passage"
          :items="passages"
          item-text="title"
          item-value="title"
          label="Select a passage"
          hint="Passage"
          persistent-hint
          single-line
          clearable
        ></v-select
      ></v-card>
      <v-row class="mx-2 my-n2">
        <v-col class="d-flex align-center">
          <v-checkbox
            class=""
            label="Use this question"
            v-model="inUse"
          ></v-checkbox
        ></v-col>
        <v-col class="d-flex justify-end align-center">
          <v-btn @click="onAddQuestion" color="primary"
            >Add Question</v-btn
          ></v-col
        ></v-row
      >
    </v-card>
  </v-container>
</template>

<script>
import * as firebase from "../firebase";
import AddingTextField from "./addingTextField";
import fileUtils from "../mixins/fileUtils";
import passages from "../mixins/passages";
import topicsHierarchy from "../mixins/topicsHierarchy";
import TopicsHierarchy from "./TopicsHierarchy";
const QUESTION_COLLECTION = "questions";
export default {
  name: "AddQuestion",
  components: { TopicsHierarchy, AddingTextField },
  mixins: [fileUtils, topicsHierarchy, passages],
  data: () => ({
    question: "",
    answers: [],
    correctAnswer: "",
    imgUrl: "",
    inUse: true,
    selectedTopics: [],
    selectedPrimaryTopics: [],
    selectedSubtopics: [],
    steps: [1, 2, 3],
    selectedStep: 1,
    passage: "",
    explanation: ""
  }),
  computed: {
    topics() {
      return this.getTopics()
        .filter(t => t.type == "primary")
        .map(t => t.topic);
    },
    passages() {
      return this.getPassages();
    }
  },
  methods: {
    onAddQuestion: function() {
      let file = document.getElementById("fileItem").files[0];
      if (file)
        this.uploadFile(file, imgUrl => {
          this.addQuestion(imgUrl);
        });
      else this.addQuestion();
    },
    addQuestion: function(imgUrl = "") {
      const answers = this.answers.map(x => x.value).filter(v => !!v);
      const data = {
        question: this.question,
        answers,
        correctAnswer: this.correctAnswer,
        inUse: this.inUse,
        primaryTopics: this.selectedPrimaryTopics,
        subtopics: this.selectedSubtopics,
        step: this.selectedStep
      };
      if (imgUrl) {
        data.imgUrl = imgUrl;
      }
      if (this.passage) {
        data.passage = this.passage;
      }
      if (this.explanation) {
        data.explanation = this.explanation;
      }
      firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection(QUESTION_COLLECTION)
        .doc()
        .set(data)
        .then(() => {
          this.$toast.open({ message: "Question added", duration: 2000 });
          const selected = this.selectedTopics;
          this.$refs.form.reset();
          this.selectedTopics = selected;
        });
    },
    onAddAnswer(answers) {
      this.answers = answers;
    },
    onNewTopics(topics) {
      this.selectedPrimaryTopics = topics.primary;
      this.selectedSubtopics = topics.subtopics;
    }
  }
};
</script>

<style scoped></style>
